module.exports = __webpack_public_path__ + "static/media/brand-story-meaning8.b345a91d.png";